const auroraColorPalette = {
  primary: {
    light: '#0088FF',
    main: '#0088FF',
    journeyBG: '#E6E6E6',
    dark: '#0088FF',
    contrastText: '#fff',
    infoGrey: '#edeff3',
    acscent: '#342D3D',
    metal: '#6C7281',
    borderColor: '#DBDEE6',
    darkerGrey: '#505050',
    grey: '#F8F8F8',
    darkGrey: '#8C9099',
    dim: '#565960',
    adgmSkyBlue: '#096BCE',
    adgmGreen: '#1C999B',
    adgmGreenLight: '#E5F0F0',
    lightADGMGreen: '#1FCACC',
    adgmGreenDark: '#019F9F',
    adgmGold: '#0088FF',
    adgmRed: '#DF2C2C',
    adgmRedLight: '#FFEBEE',
    adgmRedDark: '#A02A3C',
    adgmHover: '#006DCC',
    adgmInfo: '#0496FF',
    adgmSuccess: '#12B78E',
    adgmBlack: '#130F26',
    adgmSpace: '#3E4949',
    infoBlue: '#1270B4',
    poaSectionBg: '#FBF8F3',
    infoBlueLight: '#EBF7FF',
    warningMango: '#A76708',
    warningMangoLight: '#FFFAEB',
    successGreen: '#138266',
    successGreenLight: '#EDFDF9',
    successNew: '#005438',
    preBg: '#FDFBF9',
    successGreenNew: '#008558',
    dangerRed: '#B9350B',
    dangerRedLight: '#FDF0ED',
    errorRed: '#EA4633',
    darkErrorRed: '#A40000',
    darkWarning: '#D97706',
    davyGrey: '#5D5959',
    errorRedNew: '#A40000',
    foreground: '#2F3239',
    darksky100: '#0D2A3A',
    borderColor2: '#F6FAFF',
    black100: '#000000',
    black80: '#333333',
    black60: '#666666',
    black40: '#999999',
    black20: '#CCCCCC',
    black10: '#595B61',
    blackText: '#130F26',
    pillValueBlack: '#333333',
    white: '#FFFFFF',
    clearSky180: '#00092A',
    servicesSearchSection: '#3688F7',
    serviceChip: '#C0F8FE',
    cardHover: '#F2FEFF',
    cardHoverBorder: '#A4CFFB',
    baseColor: '#F9FBFF',
    disableBtn: '#ced1d6',
  },
  secondary: {
    light: '#190B28',
    disableLightGray: '#999',
    disableLightGray2: '#EEEFF3',
    main: '#342D3D',
    dim: '#484456',
    warningMango: '#FFAB2D',
    errorRed: '#DF2C2C',
    placeHolder: '#6C7281',
    warningMangoDark: '#B45309',
    boxChip: '#BFF8FE',
  },
};

export default auroraColorPalette;
